import { enumParser } from '#validation/common/parsers';
import { WorkspaceSuspensionReason } from '../constants';
export const workspaceSuspensionReasonParser = enumParser(WorkspaceSuspensionReason);
